module.exports = __webpack_public_path__ + "static/media/flag-grey.aa201e5f.svg";